import axios from "axios";

const axiosAPI = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        Accept: "application/json",
        // "Content-Type": "application/json",
    },
});

let isHandlingUnauthorized = false;

axiosAPI.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const requestUrl = String(error?.config?.url || '');
        const skipSessionExpiry = Boolean(error?.config?.skipSessionExpiry) || /passkey/i.test(requestUrl);

        if (status === 401 && !isHandlingUnauthorized && !skipSessionExpiry && !error?.config?.skipSessionExpired) {
            isHandlingUnauthorized = true;

            try {
                // Best-effort cleanup so redux-persist doesn't auto-restore auth state.
                localStorage.removeItem("persist:root");
            } catch (e) {
                // ignore
            }

            try {
                sessionStorage.setItem("currentPath", "/");
            } catch (e) {
                // ignore
            }

            // Use a blocking alert so the user definitely sees the timeout message
            // before redirecting to the Login screen.
            try {
                // Show a global "Session Expired" modal via App-level listener.
                window.__PMR_SESSION_EXPIRED__ = true;
                window.dispatchEvent(new Event("pmr:session-expired"));
            } catch (e) {
                // ignore
            }

            // Navigation is handled after user closes the modal in App.
        }

        return Promise.reject(error);
    }
);

export default axiosAPI;
